import { Injectable } from '@angular/core';
import {
  AppPrices,
  AppPricingApiService,
  FieldMask,
  GetMultiPricingRequest,
  GetMultiPricingResponse,
  RequestedApp,
} from '@vendasta/marketplace-apps';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppPricingService {
  constructor(private appPricingApiService: AppPricingApiService) {}

  getMultiPricing(
    appIds: string[],
    pricingContexts: FieldMask,
    partnerId: string,
    marketId: string,
    filterOptions?: FieldMask,
    requestedApps?: RequestedApp[],
    businessId?: string,
  ): Observable<AppPrices[]> {
    if (!appIds || appIds.length === 0) {
      return of(new Array<AppPrices>());
    }
    const request = new GetMultiPricingRequest({
      appIds: appIds,
      partnerId: partnerId,
      marketId: marketId,
      pricingContexts: pricingContexts,
      filterOptions: filterOptions,
      requestedApps: requestedApps,
      businessId: businessId,
    });
    return this.appPricingApiService.getMultiPricing(request).pipe(
      map((resp: GetMultiPricingResponse) => {
        return (resp || { appPrices: [] }).appPrices;
      }),
    );
  }
}
